// extracted by mini-css-extract-plugin
export default {"__sectionNoteHeading__":"section-notes___sectionNoteHeading____dGohl","__listNote__":"section-notes___listNote____PUO8t","__catatanKosong__":"section-notes___catatanKosong____KkSc5"};